<template>
    <!--弹窗-->
    <el-dialog
        width="600px"
        :title="title"
        :visible.sync="visible"
        :before-close="handleClose"
    >
        <el-form
            ref="formData"
            :model="formData"
            label-width="180px"
            size="mini"
        >
            <div class="top">
                <div style="font-weight: 900;">下载模板</div>
                <div>
                    <a
                        href="/export/listing广告数据模板.xlsx"
                        style="text-decoration: underline; color: rgb(58, 142, 230);"
                        >点击下载广告数据模板</a
                    >
                </div>
            </div>
            <div class="download">
                <el-upload
                    class="upload-demo"
                    drag
                    action="/"
                    accept=".xls, .xlsx"
                    ref="upload"
                    :file-list="files"
                    :http-request="handleUpload"
                    :on-exceed="handExceed"
                    :on-remove="handleRemove"
                    :auto-upload="false"
                    :limit="1"
                    multiple
                >
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">
                        将文件拖到此处，或<em>点击上传</em>
                    </div>
                    <div
                        class="el-upload__text"
                        style="font-size: 12px;margin-top: 5px;"
                    >
                        只能上传.xls/.xlsx文件
                    </div>
                </el-upload>
            </div>
        </el-form>
        <el-form
            ref="form"
            :inline="true"
            :rules="rules"
            :model="listData"
            class="query-form"
            size="mini"
            label-width="80px"
            style="padding: 10px 0 0 100px"
        >
            <!-- <el-form-item label="ASIN: " class="query-form-item" prop="asin">
                <el-input v-model="listData.asin" placeholder="请输入ASIN" clearable style="width: 260px;"></el-input>
            </el-form-item> -->
            <el-form-item
                label="项目组: "
                class="query-form-item"
                prop="project_name"
            >
                <el-input
                    v-model="listData.project_name"
                    placeholder="请输入项目组"
                    clearable
                    style="width: 260px;"
                ></el-input>
            </el-form-item>
            <el-form-item label="日期: " class="query-form-item" prop="dateArr">
                <el-date-picker
                    v-model="listData.dateArr"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                >
                </el-date-picker>
            </el-form-item>
        </el-form>
        <el-row style="margin-top:17px; ">
            <el-button
                style="float:right;margin-left:6px;"
                size="mini"
                type="danger"
                plain
                @click="handleClose()"
                >取 消</el-button
            >
            <el-button
                style="float:right"
                size="mini"
                type="primary"
                @click="submitForm('formData')"
                >确定</el-button
            >
        </el-row>
    </el-dialog>
</template>
<script>
import * as api from "@/api/statistics/statistics";
export default {
    data() {
        return {
            files: [],
            dateArr: [],
            rules: {
                project_name: [
                    {
                        required: true,
                        message: "请输入项目组",
                        trigger: "blur"
                    }
                ],
                dateArr: [
                    {
                        required: true,
                        message: "请选择日期",
                        trigger: "blur"
                    }
                ]
            },
            listData: {}
        };
    },
    props: {
        formData: {
            type: Object,
            default: () => {}
        },
        visible: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: ""
        },
        us_arr: {
            type: Array,
            default: () => []
        },
        state: String,
        asin: Number
    },
    methods: {
        handleUpload(raw) {
            this.files.push(raw.file);
        },
        handExceed(files, fileList) {
            this.$message({
                type: "warning",
                message: `当前限制选择 1 个文件，共选择了 ${files.length +
                    fileList.length} 个文件.`
            });
            return;
        },
        handFileSuccess() {
            this.files = [];
            this.$refs.upload.clearFiles();
        },
        handleRemove(file, fileList) {
            this.files = fileList;
        },
        // 保存信息
        submitForm() {
            this.$refs["form"].validate(valid => {
                if (valid) {
                    this.$refs.upload.submit(); // 这里是执行文件上传的函数，其实也就是获取我们要上传的文件
                    if (this.files.length == 0) {
                        this.$message.warning(`当前限制只能上传选择 1 个文件`);
                        return;
                    }
                    if (!this.listData.dateArr.length) {
                        this.$message.warning(`请选择日期`);
                        return;
                    }
                    let file = new FormData();
                    file.append("file", this.files[0]);
                    file.append("project_name", this.listData.project_name);
                    file.append("state", this.$route.query.state);
                    file.append("asin", this.$route.query.asin);
                    file.append("start_date", this.listData.dateArr[0]);
                    file.append("end_date", this.listData.dateArr[1]);
                    const loading = this.$loading({
                        lock: true,
                        text: "上传中...",
                        spinner: "el-icon-loading",
                        background: "rgba(0, 0, 0, 0.7)"
                    });
                    api.new_ad_data_add(file)
                        .then(res => {
                            if (res.code === 0) {
                                this.$message({
                                    message: "上传成功",
                                    type: "success"
                                });
                                this.disabled = false;
                                this.handleClose(true);
                            } else {
                                this.disabled = false;
                                this.$message({
                                    message: res.message,
                                    type: "error"
                                });
                            }
                        })
                        .catch(() => {
                            this.disabled = false;
                        })
                        .finally(() => {
                            loading.close();
                        });
                } else {
                    this.loading = false;
                    this.$message({
                        type: "error",
                        message: "请填写相应内容！"
                    });
                }
            });
        },
        // 关闭弹窗
        handleClose(isshow = false) {
            this.handFileSuccess();
            this.listData = {};
            this.$refs["formData"].resetFields();
            this.$emit("close-callback", isshow);
        }
    }
};
</script>
<style type="text/scss" lang="scss" scoped>
.download {
    display: flex;
    justify-content: center;
}
.top {
    margin: 0px auto;
    width: 60%;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
}
</style>
